import styled from '@emotion/styled'
import { FlexEndContainer, FlexRow, SpaceBetweenRowContainer } from './Containers'

const Wrapper = styled.div`
  container-type: inline-size;
`

const AllFields = styled(SpaceBetweenRowContainer)`
  gap: 15px 40px;

  @container (max-width: 600px) {
    flex-wrap: wrap;
  }
`

const CenterFields = styled(SpaceBetweenRowContainer)`
  width: 100%;
  text-wrap: wrap;
  word-break: break-word;

  @container (max-width: 800px) {
    flex-wrap: wrap;
  }
`

const FirstItem = styled(FlexRow)`
  min-width: 160px;
  align-items: center;

  svg {
    height: 22px;
    width: 22px;
  }

  @container (max-width: 1200px) {
    min-width: 100px;
    text-wrap: wrap;
    word-break: break-word;
  }

  @container (max-width: 600px) {
    flex-basis: 100%;
  }
`

const AssignedTo = styled(FlexRow)`
  min-width: 75px;
  align-items: center;

  @container (max-width: 600px) {
    flex-basis: 100%;
  }
`

const Item = styled.div`
  flex-basis: ${props => (props.size === 'small' ? '27%' : '34%')};

  @container (max-width: 800px) {
    flex-basis: 100%;
  }
`

const MedItem = styled(Item)`
  flex-basis: ${props => (props.size === 'small' ? '21%' : '26%')};
`

const SmallItem = styled(Item)`
  flex-basis: ${props => (props.size === 'small' ? '17%' : '20%')};
  display: flex;
  flex-direction: column;

  @container (max-width: 800px) {
    flex-direction: row;
    gap: 5px;
  }
`

const LastItem = styled(FlexEndContainer)`
  min-width: ${props => (props.size === 'small' ? '130px' : '210px')};
  text-wrap: nowrap;
  text-align: right;

  @container (max-width: 1200px) {
    min-width: ${props => (props.size === 'small' ? '130px' : '130px')};
    text-wrap: wrap;
  }

  @container (max-width: 600px) {
    justify-content: flex-start;
  }
`

export { Wrapper, AllFields, CenterFields, AssignedTo, FirstItem, Item, MedItem, SmallItem, LastItem }
